export default "__VITE_ASSET__ConoOAb8__"